import { ChargeDetail } from "@/types/charge";

/**
 * Normalizes charges to ensure all payments have feeToPatient set.
 * This is required because the backend schema expects feeToPatient to be present,
 * but charges coming from the backend may have payments without this field.
 */
export function normalizeChargesForApi(
  charges: ChargeDetail[],
): ChargeDetail[] {
  return charges.map((charge) => ({
    ...charge,
    payments: (charge.payments ?? []).map((chargePayment) => ({
      ...chargePayment,
      payment: chargePayment.payment
        ? {
            ...chargePayment.payment,
            feeToPatient: chargePayment.payment.feeToPatient ?? 0,
          }
        : chargePayment.payment,
    })),
  }));
}
